
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.91","height":"33.91"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"33.91","height":"33.91","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#c2d5e1","flood-opacity":".988"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"Group 8006"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 5033","d":"M12.536 6h8.839a3.536 3.536 0 013.535 3.536v8.839a3.536 3.536 0 01-3.536 3.536h-8.838A3.536 3.536 0 019 18.375V9.536A3.536 3.536 0 0112.536 6z","fill":"#fff"}})]),_c('path',{attrs:{"data-name":"Path 5032","d":"M13.335 11.857l3.979 4.569 10.022-9.8","fill":"none","stroke":"#64d282","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}})])])
          )
        }
      }
    